export default {
  "noImageURLReturned": "No image URL returned",
  "imageUploaded": "Image uploaded",
  "uploadFailed": "Upload failed",
  "thisDesignHasUnsavedChangesSwitching": "This design has unsaved changes. Switching will discard them. Continue?",
  "switchDesign": "Switch design",
  "home": "Home",
  "couldNotLoadHomeDesigns": "Could not load home designs",
  "enterADesignName": "Enter a design name",
  "newHomeDesign": "New home design",
  "nameIsRequired": "Name is required",
  "homeDesignCreated": "Home design created",
  "couldNotCreateDesign": "Could not create design",
  "restoreThisDraftToTheDefault": "Restore this draft to the default template. Its name, home designation and published content are preserved. Unsaved changes will be lost. Continue?",
  "restoreDefault": "Restore default",
  "draftRestoredPublishAgainToUpdate": "Draft restored. Publish again to update the live page.",
  "couldNotRestoreDefault": "Could not restore default",
  "keepAtLeastOneHomeDesign": "Keep at least one home design",
  "currentDesign": "Current design",
  "deleteDesign": "Delete design",
  "delete": "Delete",
  "designDeleted": "Design deleted",
  "couldNotDeleteDesign": "Could not delete design",
  "theMiniProgramWillDisplayThis": "The mini-program will display this design's published content. Ensure it has been published. Continue?",
  "setHome": "Set home",
  "setAsHomePage": "Set as home page",
  "couldNotSetHomeDesign": "Could not set home design",
  "draftSaved": "Draft saved",
  "couldNotSaveDraft": "Could not save draft",
  "couldNotLoadDraftPreview": "Could not load draft preview",
  "saveTheCurrentChangesBeforePublishing": "Save the current changes before publishing?",
  "publishHome": "Publish home",
  "usersWillSeeThisDesignAfter": "Users will see this design after publication. Publish now?",
  "thisIsNotTheHomeDesign": "This is not the home design. Publishing updates its live version; the mini-program still displays the designated home design. Publish now?",
  "designPublished": "Design published",
  "couldNotPublishHomeDesign": "Could not publish home design",
  "couldNotLoadHomeDraft": "Could not load home draft",
  "homePage": "Home page design",
  "selectAHomeDesign": "Select a home design",
  "newDesign": "New design",
  "currentHome": "Current home",
  "unsavedChanges": "Unsaved changes",
  "draftSaved1": "Draft saved",
  "saveDraft": "Save draft",
  "previewDraft": "Preview draft",
  "basic": "Basic components",
  "utilityComponents": "Utility components",
  "addComponentsFromTheLeft": "Add components from the left",
  "moveUp": "Move up",
  "moveDown": "Move down",
  "duplicate": "Duplicate",
  "props": "Properties",
  "titleBar": "Title bar",
  "designName": "Design name",
  "pageTitle": "Page title",
  "titleColor": "Title color",
  "black": "Black",
  "white": "White",
  "titleBarBackground": "Title bar background",
  "contentArea": "Content area",
  "backgroundColor": "Background color",
  "reset": "Reset",
  "backgroundImageURL": "Background image URL",
  "upload": "Upload",
  "verticalPadding": "Vertical padding",
  "horizontalPadding": "Horizontal padding",
  "selectAComponentOnTheCanvas": "Select a component on the canvas",
  "draftPreview": "Draft preview",
  "noComponentsAdded": "No components added",
  "navigation": "Navigation",
  "cell": "Cell",
  "carousel": "Carousel",
  "image": "Image",
  "recommendedCarouselSize750360": "Recommended carousel size: 750 × 360",
  "recommendedImageSize750360": "Recommended image size: 750 × 360",
  "recommendedImageSize100100": "Recommended image size: 100 × 100",
  "imageGridsSupportUpTo4": "Image grids support up to 4 images",
  "navigationTitle": "Navigation title",
  "timelineEntry": "Timeline entry",
  "contentSettings": "Content settings",
  "imageURL": "Image URL",
  "content": "Content",
  "type": "Type",
  "selectAType": "Select a type",
  "settings": "Configure",
  "addNavigationItem": "Add navigation item",
  "addImage": "Add image",
  "button": "Button",
  "addButton": "+ Add button",
  "title": "Title",
  "buttonText": "Button text",
  "buttonType": "Button type",
  "text": "Text",
  "icon": "Icon",
  "videoURL": "Video URL",
  "coverImage": "Cover image",
  "latitude": "Latitude",
  "longitude": "Longitude",
  "placeholder": "Placeholder",
  "announcement": "Announcement",
  "showIcon": "Show icon",
  "text2": "Text",
  "alignment": "Alignment",
  "left": "Left",
  "center": "Center",
  "right": "Right",
  "richTextContent": "Rich text content",
  "entry": "Entry",
  "date": "Date",
  "addEntry": "Add entry",
  "selectIcon": "Select icon",
  "associationName": "Association name",
  "iconURL": "Icon URL",
  "height": "Height",
  "contentIsLoadedFromTheMini": "Content is loaded from the mini-program API at runtime. Configure only its appearance and item count here.",
  "showTitle": "Show title",
  "titleText": "Title text",
  "rightButton": "Right button",
  "itemCount": "Item count",
  "showImages": "Show images",
  "showViewCount": "Show view count",
  "showContactDetails": "Show contact details",
  "noEditableContent": "No editable content",
  "styleSettings": "Style settings",
  "slideIntervalMs": "Slide interval (ms)",
  "componentHeight": "Component height",
  "itemsPerRow": "Items per row",
  "iconSize": "Icon size",
  "columns": "Columns",
  "mapHeight": "Map height",
  "lineStyle": "Line style",
  "solid": "Solid",
  "dashed": "Dashed",
  "dotted": "Dotted",
  "lineColor": "Line color",
  "fontSize": "Font size",
  "textColor": "Text color",
  "buttonColor": "Button color",
  "buttonSize": "Button size",
  "rightOffset": "Right offset",
  "bottomOffset": "Bottom offset",
  "opacity": "Opacity",
  "componentCornerRadius": "Component corner radius",
  "textSize": "Text size",
  "fontColor": "Font color",
  "autoScroll": "Auto scroll",
  "off": "Off",
  "on": "On",
  "scrollIntervalMs": "Scroll interval (ms)",
  "scrollDurationMs": "Scroll duration (ms)",
  "iconSize3": "Icon size",
  "iconCornerRadius": "Icon corner radius",
  "cornerStyle": "Corner style",
  "none": "None",
  "partial": "Partial",
  "full": "Full",
  "positionBadgeRadius": "Position badge radius",
  "positionFontSize": "Position font size",
  "positionTextColor": "Position text color",
  "positionBackground": "Position background",
  "nameFontSize": "Name font size",
  "nameColor": "Name color",
  "imageCornerRadius": "Image corner radius",
  "enterSearchKeywords": "Enter search keywords",
  "recommendedWidth750AnyHeight": "Recommended width: 750; any height",
  "singleImage": "Single image",
  "icon4": "↗",
  "imageGrid": "Image grid",
  "infoCard": "Info card",
  "details": "Details",
  "viewMore": "View more",
  "videoComponent": "Video",
  "map": "Map ·",
  "more": "More",
  "member": "Member",
  "memberName": "Member name",
  "album": "Album",
  "exampleEventTitle": "Example event title",
  "0101800Mon": "01/01 8:00 · Mon",
  "qingdaoShandong": "Qingdao, Shandong",
  "exampleArticleTitleContentDependsOn": "Example article title; content depends on the selected news",
  "example": "Example",
  "loadedFromTheMiniProgramAPI": "Loaded from the mini-program API at runtime",
  "icon5": "ⓘ",
  "associationProfile": "Association profile",
  "spacer": "Spacer",
  "notifications": "Notifications",
  "enterText": "Enter text",
  "noticeTitle": "Notice title",
  "noticeContent": "Notice content",
  "icon6": "●",
  "enterAnExternalURL": "Enter an external URL",
  "externalLink": "External link",
  "enterAPhoneNumber": "Enter a phone number",
  "miniProgramSupport": "Mini-program support",
  "selectALinkType": "Select a link type",
  "path": "Path",
  "pageParametersOptional": "Page parameters (optional)",
  "eGId2": "e.g. id=2",
  "actions": "Actions",
  "select": "Select",
  "1AddTheBusinessDomainBefore": "1. Add the business domain before linking to an external page.",
  "2AddItInWeChatPublic": "2. Add it in WeChat Public Platform → Development → Development management → Development settings → Business domains.",
  "enterAURL": "Enter a URL",
  "phoneNumber": "Phone number",
  "description": "Description",
  "1AvailableOnlyInWeChatMini": "1. Available only in WeChat mini-programs.",
  "2OpensCustomerSupportInThis": "2. Opens customer support in this mini-program.",
  "cancel": "Cancel",
  "oK": "OK",
  "informationCardTitle": "Information card title",
  "informationCardContent": "Information card content",
  "buttonText1": "Button text 1",
  "buttonText2": "Button text 2",
  "buttonText3": "Button text 3",
  "news": "News",
  "memberList": "Member list",
  "associationEvents": "Association events",
  "eventAlbums": "Event albums",
  "memberSupplyAndDemand": "Member supply and demand",
  "thisIsACustomNotification": "This is a custom notification",
  "textContentGoesHere": "Text content goes here",
  "spanRichTextContentGoesHere": "Rich text content goes here",
  "membershipApplications": "Membership applications",
  "editProfile": "Edit profile",
  "membershipFeePayments": "Membership fee payments",
  "memberShowcase": "Member showcase",
  "activityList": "Activity list",
  "eventDetails": "Event details",
  "eGId2EventID": "e.g. id=2 (event ID)",
  "myEvents": "My events",
  "listings": "Listings",
  "supplyAndDemandDetails": "Supply and demand details",
  "eGId2ListingID": "e.g. id=2 (listing ID)",
  "myPosts": "My posts",
  "postSupplyOrDemand": "Post supply or demand",
  "articles": "Articles",
  "articleDetails": "Article details",
  "eGId2ArticleID": "e.g. id=2 (article ID)",
  "fAQ": "FAQ",
  "settings7": "Settings",
  "userAgreement": "User agreement",
  "privacyPolicy": "Privacy policy",
  "membershipAgreement": "Membership agreement",
  "internalPage": "Internal page",
  "callPhone": "Phone call",
  "message1": "{p0} (Home)",
  "message2": "Home design {p0}",
  "message3": "“{p0}” is the current home design. Deleting it will designate another design as home and remove its drafts and publication history. Delete now?",
  "message4": "Delete “{p0}” and all its drafts and publication history?",
  "message5": "Button text {p0}",
  "message6": "Button {p0}",
  "searchComponent": "Search",
  "lineComponent": "Divider",
  "floatComponent": "Floating button",
  "mapComponent": "Map"
}
